<template>
  <div
    class="bg-gray-700 text-white text-lg p-8 mt-4 flex flex-col items-center justify-center gap-2"
  >
    <div class="flex items-center gap-2">
      <span>Made with</span>
      <svg
        width="24"
        height="24"
        viewBox="0 0 261.76 226.69"
        xmlns="http://www.w3.org/2000/svg"
        class="inline-block align-middle"
        style="vertical-align: middle;"
      >
        <title>{{ 'Vue.js ' + vueVersion }}</title>
        <g>
          <path
            d="M33.36,0L0,57.67l130.88,226.69L261.76,57.67,228.4,0H33.36Z"
            fill="#41b883"
          />
          <path
            d="M33.36,0L0,57.67l130.88,226.69L261.76,57.67,228.4,0H33.36Zm0,0,97.52,169.01L228.4,0H33.36Z"
            fill="#34495e"
          />
          <path
            d="M33.36,0,130.88,169.01,228.4,0H33.36Z"
            fill="#41b883"
          />
          <path
            d="M130.88,169.01,33.36,0H228.4L130.88,169.01Z"
            fill="#34495e"
          />
          <path
            d="M130.88,129.01,33.36,0H228.4L130.88,129.01Z"
            fill="#41b883"
          />
        </g>
      </svg>
      <span>by
        <a
          href="https://jakobcarlbring.com"
          target="_blank"
          rel="noopener"
          class="underline hover:text-green-400"
        >Jakob Carlbring</a></span>
    </div>
    <div class="text-sm text-gray-300">
      Visual design and illustrations by
      <a
        href="https://www.princesslargo.com/"
        target="_blank"
        rel="noopener"
        class="underline hover:text-green-400"
      >Princess Largo</a>
    </div>
  </div>
</template>
<script>
import pkg from '../../package.json'
export default {
  name: 'AppFooter',
  computed: {
    vueVersion() {
      return pkg.dependencies.vue.replace('^', 'v')
    }
  }
}
</script>
